"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATE_TIME_FORMAT = exports.convertDuration = exports.getTotalDuration = exports.getPTOBalance = exports.getHoursAndMinutesFromDuration = exports.getSummaryFromPaycodes = exports.validate12HourFormatTime = exports.convertDurationInHours = exports.FONT_COLOR = void 0;
const luxon_1 = require("luxon");
var FONT_COLOR;
(function (FONT_COLOR) {
    FONT_COLOR["STENCIL_RED"] = "red70";
})(FONT_COLOR = exports.FONT_COLOR || (exports.FONT_COLOR = {}));
const convertDurationInHours = (duration) => {
    return duration / 60;
};
exports.convertDurationInHours = convertDurationInHours;
const validate12HourFormatTime = (timeIn12HourFormat) => {
    return (/^(1[0-2]|0?[1-9]):[0-5][0-9] (am|pm)$/gm.test(timeIn12HourFormat) ||
        /^(1[0-2]|0?[1-9]):[0-5][0-9] (A|P)$/gm.test(timeIn12HourFormat));
};
exports.validate12HourFormatTime = validate12HourFormatTime;
const getSummaryFromPaycodes = (response, timezone, paycodeType) => {
    const vtoSummaryArray = [];
    const paycodesList = response.payCodes;
    const count = 0;
    paycodesList === null || paycodesList === void 0 ? void 0 : paycodesList.map((paycode, index) => {
        var _a;
        if (paycode.payCodeName === paycodeType) {
            vtoSummaryArray.push({
                id: index,
                startDate: (_a = paycode.startDateTime) === null || _a === void 0 ? void 0 : _a.substring(0, 10),
                startTime: luxon_1.DateTime.fromISO(paycode.startDateTime)
                    .setZone(timezone)
                    .toString()
                    .substring(11, 16),
                duration: paycode.duration
            });
        }
    });
    return vtoSummaryArray;
};
exports.getSummaryFromPaycodes = getSummaryFromPaycodes;
const getHoursAndMinutesFromDuration = (duration) => {
    const hours = Math.floor(duration);
    const minutes = Math.round((duration - hours) * 60);
    if (hours == 0) {
        return `${minutes} min`;
    }
    else if (hours && minutes == 0) {
        return `${hours} hr`;
    }
    return `${hours} hr ${minutes} min`;
};
exports.getHoursAndMinutesFromDuration = getHoursAndMinutesFromDuration;
const getPTOBalance = (balances) => {
    let ptoBalance = 0;
    balances === null || balances === void 0 ? void 0 : balances.forEach((balance) => {
        if (balance.balanceId === 'US AMZN Personal Time Off') {
            ptoBalance = balance.encumberedMinutes;
        }
    });
    return ptoBalance;
};
exports.getPTOBalance = getPTOBalance;
const getTotalDuration = (vtoSummary, isChecked) => {
    let totalDuration = 0;
    let numberOfRequests = 0;
    isChecked.map((isChecked, index) => {
        if (isChecked) {
            totalDuration += vtoSummary[index].duration;
            numberOfRequests++;
        }
    });
    return { totalDuration, numberOfRequests };
};
exports.getTotalDuration = getTotalDuration;
const convertDuration = (duration) => {
    return `${Math.floor(duration / 60)}:${(duration % 60)
        .toString()
        .padStart(2, '0')}`;
};
exports.convertDuration = convertDuration;
var DATE_TIME_FORMAT;
(function (DATE_TIME_FORMAT) {
    DATE_TIME_FORMAT["DATETIME_IN_ISO"] = "yyyy-MM-dd'T'HH:mm:ss'Z'";
})(DATE_TIME_FORMAT = exports.DATE_TIME_FORMAT || (exports.DATE_TIME_FORMAT = {}));
